export default "__VITE_ASSET__DoaUKPwU__"